import { useQuery } from "@tanstack/react-query";
import { QueryBuilder } from "features/members";
import { axios } from "lib/axios";

export const getTeamBudgetsPaginated = ({
  churchId,
  teamId,
  page,
  pageSize,
  queries
}) => {
  const queryBuilder = new QueryBuilder();

  queryBuilder.pagination(page, pageSize);

  if (queries.filter) {
    queryBuilder.filter(queries.filter);
  }

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  if (queries.sort) {
    queryBuilder.sort(queries.sort);
  }

  const queryString = queryBuilder.build();

  return axios.get(
    `/churches/${churchId}/team-budgets/${teamId}${queryString}`
  );
};

export const useTeamBudgetsPaginated = ({
  churchId,
  teamId,
  page,
  pageSize,
  queries = {},
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "team-budgets",
      page,
      pageSize,
      churchId,
      teamId,
      JSON.stringify(queries)
    ],
    queryFn: () =>
      getTeamBudgetsPaginated({ churchId, teamId, page, pageSize, queries })
  });
};
